<template>
  <section class="my-5">
    <h2>クーリング・オフお申し出フォーム</h2>
    <div class="form-navi my-5">
      <ul class="d-flex">
        <li>入力</li>
        <li>内容確認</li>
        <li class="here">送信完了</li>                
      </ul>    
    </div>
    <p>お問い合わせいただきましてありがとうございます。<br>折り返しご連絡いたしますので、もうしばらくお待ちください。</p>
    <p class="mt-5">確認用のメールが届かない場合は、お手数ですが再度お問い合わせください。</p>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br>
      ◆お問い合わせ:0120-268-510<br>
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();
export default {
  mounted() {
    auth.removeNoLoginUid();
    window.scroll(0, 0);
  },
}
</script>
